/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeRestrictionValidationData,
    DateTimeRestrictionValidationDataFromJSON,
    DateTimeRestrictionValidationDataFromJSONTyped,
    DateTimeRestrictionValidationDataToJSON,
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRV2RuleValidationData
 */
export interface SSRV2RuleValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRV2RuleValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRV2RuleValidationData
     */
    contactEmail?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRV2RuleValidationData
     */
    contactMobile?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRV2RuleValidationData
     */
    carriers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRV2RuleValidationData
     */
    bookingDateTimeRestrictionsTimeZone?: ValidationMessage;
    /**
     * 
     * @type {Array<DateTimeRestrictionValidationData>}
     * @memberof SSRV2RuleValidationData
     */
    bookingDateTimeRestrictions?: Array<DateTimeRestrictionValidationData> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof SSRV2RuleValidationData
     */
    travelDates?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SSRV2RuleValidationData
     */
    brandAndMarket?: ValidationMessage;
}

export function SSRV2RuleValidationDataFromJSON(json: any): SSRV2RuleValidationData {
    return SSRV2RuleValidationDataFromJSONTyped(json, false);
}

export function SSRV2RuleValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'contactEmail': !exists(json, 'contactEmail') ? undefined : ValidationMessageFromJSON(json['contactEmail']),
        'contactMobile': !exists(json, 'contactMobile') ? undefined : ValidationMessageFromJSON(json['contactMobile']),
        'carriers': !exists(json, 'carriers') ? undefined : ValidationMessageFromJSON(json['carriers']),
        'bookingDateTimeRestrictionsTimeZone': !exists(json, 'bookingDateTimeRestrictionsTimeZone') ? undefined : ValidationMessageFromJSON(json['bookingDateTimeRestrictionsTimeZone']),
        'bookingDateTimeRestrictions': !exists(json, 'bookingDateTimeRestrictions') ? undefined : (json['bookingDateTimeRestrictions'] === null ? null : (json['bookingDateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionValidationDataFromJSON)),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
    };
}

export function SSRV2RuleValidationDataToJSON(value?: SSRV2RuleValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'contactEmail': ValidationMessageToJSON(value.contactEmail),
        'contactMobile': ValidationMessageToJSON(value.contactMobile),
        'carriers': ValidationMessageToJSON(value.carriers),
        'bookingDateTimeRestrictionsTimeZone': ValidationMessageToJSON(value.bookingDateTimeRestrictionsTimeZone),
        'bookingDateTimeRestrictions': value.bookingDateTimeRestrictions === undefined ? undefined : (value.bookingDateTimeRestrictions === null ? null : (value.bookingDateTimeRestrictions as Array<any>).map(DateTimeRestrictionValidationDataToJSON)),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(ListItemValidationMessageToJSON)),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
    };
}


